import Component from '@glimmer/component';
import { service } from '@ember/service';
import { trackedFunction } from 'reactiveweb/function';
import type { Store } from '@warp-drive/core';
import type { ApplicationApprovalSummaryApprover } from '../../../types/tuition-assistance.ts';
import { LinkTo } from '@ember/routing';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import type IntlService from 'ember-intl/services/intl';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import { findRecord } from '@warp-drive/utilities/json-api';

export interface TuitionAssistanceApplicationDetailsApproverQueueEmployeeInfoSignature {
  Args: {
    consumingApp: string;
    reviewer: ApplicationApprovalSummaryApprover;
    cellClass: string;
  };
}

export default class TuitionAssistanceApplicationDetailsApproverQueueEmployeeInfoComponent extends Component<TuitionAssistanceApplicationDetailsApproverQueueEmployeeInfoSignature> {
  @service declare store: Store;
  @service declare intl: IntlService;

  employeeState = trackedFunction(this, async () => {
    const { employee_id } = this.args.reviewer;

    if (!employee_id) {
      return null;
    }

    try {
      const { content } = (await this.store.request(
        findRecord<EmployeeModel>('employee', String(employee_id), {
          include: 'person',
        })
      )) as { content: { data: EmployeeModel } };
      return content.data;
    } catch {
      return null;
    }
  });

  get employeeFullName() {
    const employee = this.employeeState.value;
    const name = employee?.fullName?.trim();
    return (
      name ||
      this.intl.t('tuition_assistance.approval_queue.employee_fallback', {
        id: this.args.reviewer.employee_id,
      })
    );
  }

  get employeePersonId() {
    return this.employeeState.value?.person?.id;
  }

  <template>
    {{#if (eq @reviewer.dot "TAS.Approver.TIO_APPROVER")}}
      <td class={{@cellClass}} colspan="2">
        {{t (concat "tuition_assistance.approval_queue.roles." @reviewer.dot)}}
      </td>
    {{else}}
      <td class={{@cellClass}}>
        {{#if (eq @consumingApp "tio-admin")}}
          <LinkTo
            @route="authenticated.people.show"
            @model={{this.employeePersonId}}
            class="tio-copy"
          >
            {{this.employeeFullName}}
          </LinkTo>
        {{else}}
          {{this.employeeFullName}}
        {{/if}}
      </td>
      <td class={{@cellClass}}>
        {{t (concat "tuition_assistance.approval_queue.roles." @reviewer.dot)}}
      </td>
    {{/if}}
  </template>
}
